export default async function (ctx) {
  // if route match /team/<club-slug>/trainer/<trainer-id>
  if (ctx.route.name === 'team_club_trainer') {
    const { club: clubSlug, trainer: trainerId } = ctx.route.params

    const id = `fitbase/${clubSlug}/trainers/${trainerId}`
    const trainer =
      ctx.store.state.modules.content[id] || (await ctx.store.dispatch('modules/content/getContent', { id })) || {}

    const currentClubSlug = trainer?.filial[0]?.slug

    !currentClubSlug && ctx.redirect(`/team/${clubSlug}`)

    // If trainer changed club redirect from old to new club
    currentClubSlug !== clubSlug && ctx.redirect(`/team/${currentClubSlug}/trainer/${trainerId}`)
  }
}
